class ImageWithPoints extends HTMLElement {
    constructor() {
        super();
        this.btnEventListners();
        this.hoverEventListners();
    }

    btnEventListners() {
        const { pointElements, mainMapImage } = this.pointsComponents();
        
        pointElements.forEach(element => {
            element.addEventListener('click', () => {         
                const tooltipElement = element.querySelector('.tooltip-element');
                if(tooltipElement.classList.contains('block')) {
                    this.hideAllTooltips();
                } else {
                    this.toggleTooltip(element);
                }
            });
        });

        mainMapImage.forEach(image => {
            image.addEventListener('click', () => {
                this.hideAllTooltips();
            });
        })

    }

    hoverEventListners() {
        const { pointElements, tooltipElements } = this.pointsComponents();
        pointElements.forEach(element => {
            element.addEventListener('mouseover', () => {
                this.toggleTooltip(element);
            });
        });

        tooltipElements.forEach(toolTipElement => {
            toolTipElement.addEventListener('mouseleave', () => {
                this.hideAllTooltips();
            })
        })

    }

    toggleTooltip(element) {
        this.hideAllTooltips();
        const tooltipElement = element.querySelector('.tooltip-element');
        const starShadow = element.querySelector('.star-shadow');
        tooltipElement.classList.replace('hidden', 'block');
        starShadow.classList.replace('hidden', 'block');
    }

    hideAllTooltips() {
        const { tooltipElements, starShadows } = this.pointsComponents();
        tooltipElements.forEach(element => {
            element.classList.replace('block', 'hidden');
        });
        starShadows.forEach(element => {
            element.classList.replace('block', 'hidden');
        });
    }

    pointsComponents() {
        const pointElements = this.querySelectorAll('.point-element');
        const tooltipElements = this.querySelectorAll('.tooltip-element');
        const mainMapImage = this.querySelectorAll('.main-map-image');    
        const starShadows = this.querySelectorAll('.star-shadow');
        
        return { pointElements, tooltipElements, mainMapImage, starShadows };
    }
}

customElements.define('points-map', ImageWithPoints);